const e="data-roq-theme-mode";export{e as THEME_MODE_ATTRIBUTE};